import { useEffect, useState } from 'react'
import type { GeoFix } from './types'

export type PhoneFix = { state: 'locating' } | { state: 'ok'; fix: GeoFix } | { state: 'none' }

/**
 * The phone's position while a check-out / check-in dialog is open, for the fleet map. Optional:
 * a refusal or a timeout just means no position is sent.
 */
export function usePhoneFix(): PhoneFix {
  const [fix, setFix] = useState<PhoneFix>(() => ('geolocation' in navigator ? { state: 'locating' } : { state: 'none' }))
  useEffect(() => {
    if (!('geolocation' in navigator)) return
    let live = true
    navigator.geolocation.getCurrentPosition(
      (p) => live && setFix({ state: 'ok', fix: { lat: p.coords.latitude, lng: p.coords.longitude, accuracyM: Math.round(p.coords.accuracy) } }),
      () => live && setFix({ state: 'none' }),
      { enableHighAccuracy: true, timeout: 12_000, maximumAge: 60_000 },
    )
    return () => { live = false }
  }, [])
  return fix
}

export const fixOrNull = (f: PhoneFix): GeoFix | null => (f.state === 'ok' ? f.fix : null)
